module.exports = __webpack_public_path__ + "img/water-old.d167a06b.png";